import React, { useEffect, useState } from "react"
import CartItemTile from "@/components/cart/CartItemTile"
import Button from "@/components/core/Button/Button"

import SocialShare from "@/components/cart/OrderSummary/SocialShare"
import { analyticEventData } from "@/components/cart/OrderSummary/cartContstants"
import { getCartCount } from "@/utils/cart"

import { selectGenericState } from "@/store/features/genericSlice"
import { isMobile } from "react-device-detect"
import { authorBaseUrl, baseUrl } from "@/constants/index"
import printIcon from "@/public/icons/print-grey.svg"
import { setAuthModalVisibility } from "@/store/features/authSlice"
import { useDispatch, useSelector } from "react-redux"
import ShippingFiller from "@/components/checkout/ShippingFiller"
import {
  addAnalyticsClickContinueShopping,
  addAnalyticsClickSignIn,
} from "@/components/cart/analytics"

const CartItems = props => {
  const {
    i18n,
    dispatchCallback,
    cartItems = [],
    loading: isLoading,
    cartId,
    cartKey = "",
    mode,
    showAlert,
    title,
    isMerge,
    onMerge,
    isAuth,
    username,
    checkoutMode,
    isIscUser,
    cartDataStatus,
    ...restProps
  } = props

  const [count, setCount] = useState(0)
  const dispatch = useDispatch()

  useEffect(() => {
    let count = 0
    cartItems?.map(item => (count += item.quantity))
    setCount(count)
  }, [cartItems])

  let alertCount = 0
  cartItems?.forEach(item => {
    if (item.outOfStock || item.noShipping) alertCount++
  })

  const { globalConfig } = useSelector(selectGenericState)

  const { general: { shareCartPagePath = "" } = {} } = globalConfig

  const showAuthModal = () => {
    addAnalyticsClickSignIn()
    dispatch(setAuthModalVisibility({ show: true }))
  }

  const urlParams = new URLSearchParams(window.location.search)
  const isTestPage = urlParams.get("testPage")

  const handleClickTest = () => {
    window.location.href = authorBaseUrl + shareCartPagePath
  }

  const isCartItems = Boolean(cartItems?.length)
  if (!cartDataStatus) return <ShippingFiller />
  const cartCount = getCartCount()

  return (
    <>
      <div
        className={`${
          !isCartItems && !isIscUser ? "no-padding " : ""
        } cart-landing__content`}
        data-testid="cartItemTile"
      >
        <div className="row no-gutters cart-items">
          <div className="col">
            <div className={`row no-gutters`}>
              <div className="col-lg-12 col-sm-6 col-md-6 cart-header">
                {mode !== "share" && (isIscUser || isCartItems) ? (
                  <>
                    <div
                      className="cart-items__title"
                      role="heading"
                      aria-level="1"
                      aria-label={`${i18n.yourCart} ${count} items`}
                      data-testid="cartItem-title"
                    >
                      {i18n.yourCart} ({cartCount})
                    </div>
                    {isTestPage ? (
                      <button onClick={handleClickTest}>Test Error msg</button>
                    ) : null}
                    <div className="cart-id-share">
                      {cartKey ? (
                        <span className="share-cart-id">
                          {i18n.yourSharedCartID(cartKey)}
                        </span>
                      ) : null}

                      {!checkoutMode && (
                        <SocialShare
                          id="kf-order-summary"
                          dispatchCallback={dispatchCallback}
                          cartId={cartId}
                          analyticEventData={analyticEventData}
                        />
                      )}
                    </div>
                    {cartKey ? (
                      <p className="mobile-share-cart-id">
                        {i18n.yourSharedCartID(cartKey)}
                      </p>
                    ) : null}
                  </>
                ) : null}
                {mode === "share" && (
                  <div
                    className="cart-items__title"
                    role="heading"
                    aria-level="1"
                    aria-label={`${title} ${count} items`}
                    data-testid="cartItem-title"
                  >
                    {title} ({isCartItems ? count : 0})
                  </div>
                )}
              </div>
              {!isMobile && mode === "share" && (
                <div className="col-12 col-sm-6 col-md-6">
                  <div className="cart-items__download-print d-none d-lg-flex">
                    <span
                      role="link"
                      tabIndex="0"
                      onClick={() => window.print()}
                    >
                      <img src={printIcon?.src} alt={i18n.print} />
                      {i18n.print}
                    </span>
                  </div>
                </div>
              )}
            </div>
            {mode !== "share" && showAlert && (
              <div className="row no-gutters">
                <div className="cart-items__alert">
                  <span
                    role="alert"
                    tabIndex="0"
                    className="cart-items__alert-title"
                  >{`${i18n.alert}: `}</span>
                  {`${alertCount} ${i18n.outOfStockAlert}`}
                </div>
              </div>
            )}
            {mode === "share" && (
              <div className={`row no-gutters`}>
                <div className="col-12">
                  <div className="order-summary ">
                    <Button
                      customClass="cart-items__checkout-btn"
                      label={isMerge ? i18n.mergeWithCart : i18n.addToMyCart}
                      flexible
                      type="black"
                      onClick={onMerge}
                    />
                  </div>
                </div>
              </div>
            )}
            {isMobile && mode === "share" && (
              <div className="row cart-items__th--mobile no-gutters">
                <div className="col-12 col-sm-6 col-md-6 d-none d-sm-block"></div>
                <div className="col-12 col-sm-6 col-md-6">
                  <div className="cart-items__download-print d-none d-lg-flex">
                    <span
                      role="link"
                      tabIndex="0"
                      onClick={() => window.print()}
                    >
                      <img src={printIcon?.src} alt={i18n.print} />
                      {i18n.print}
                    </span>
                  </div>
                </div>
              </div>
            )}
            <div
              className={`row cart-items__th no-gutters ${
                isIscUser || isCartItems ? "cart-table-header" : ""
              }`}
            >
              {isCartItems || isIscUser ? (
                <div className="col-12 col-sm-6 col-md-6 d-sm-block">
                  <div
                    className="col-4 d-none d-sm-block text-left cart-items__td px-0"
                    aria-label={i18n?.item}
                  >
                    {i18n.item}
                  </div>
                </div>
              ) : null}
              <div className="col-12 col-sm-6 col-md-6">
                {isCartItems || isIscUser ? (
                  <div className="row mx-0 px-0">
                    <div
                      className="col-6 d-none d-sm-block  cart-items__td cart-td-unit-price"
                      aria-label={i18n?.itemPrice}
                    >
                      {i18n.itemPrice}
                    </div>
                    <div
                      className="col-4 d-none d-sm-block text-left cart-items__td px-0"
                      aria-label={i18n?.qty}
                    >
                      {i18n.qty}
                    </div>
                    <div
                      className="col-2 d-none d-sm-block text-right cart-items__td px-0"
                      aria-label={i18n?.total}
                    >
                      {i18n.total}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            {!isIscUser && !isCartItems && !isLoading ? (
              <div className="cart-items__no-items no-border">
                <div className="cart-items__no-items-message text-center">
                  {`${username ? username + "," : ""}`}{" "}
                  {i18n.noItemsInCart?.toLowerCase()}
                </div>
                {!isAuth ? (
                  <p className="sing-in-cart-message text-center">
                    {" "}
                    {i18n.signInItemsPreviously}{" "}
                  </p>
                ) : null}
                <section className="cart-items__no-items-links d-flex text-center">
                  {!isAuth ? (
                    <Button
                      label="Sign In"
                      className="gbh-data-layer sing-in-cart"
                      type="black"
                      role="button"
                      tabIndex={0}
                      onClick={showAuthModal}
                    />
                  ) : null}
                  <Button
                    label={i18n.continueShopping}
                    tag="anchor"
                    useDefaultClass={true}
                    type="ghost"
                    to={baseUrl}
                    onClick={() => addAnalyticsClickContinueShopping(baseUrl)}
                  />
                </section>
              </div>
            ) : null}
            {cartItems?.map(item => (
              <CartItemTile
                key={item.id}
                i18n={i18n}
                loading={isLoading}
                {...restProps}
                data={item}
                dispatchCallback={dispatchCallback}
                checkoutMode={mode === "share"}
                zipCode={item?.zipCode}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default CartItems
